/* Cuddypup: Pumper-inspired treatment for Mageworx volume discounts. */
(() => {
  if (window.__cuddypupMageworxVolumeBundle) return;
  window.__cuddypupMageworxVolumeBundle = true;

  const STYLE_ID = 'cuddypup-mageworx-volume-bundle';
  const THEME_VARIANTS_STYLE_ID = 'cuddypup-mageworx-volume-theme-variants';
  const THEME_VARIANTS_SCOPE_CLASS = 'cuddypup-volume-theme-variants';
  const STOCK_HIDDEN_CLASS = 'cuddypup-volume-stock-hidden';
  const STOCK_HIDDEN_TIER_CLASS = 'cuddypup-volume-tier-stock-hidden';
  const observedRoots = new WeakSet();
  const priceStates = new WeakMap();
  const inventoryByVariantId = new Map();
  let storefrontProduct = null;
  let productLoadStarted = false;
  let inventoryLoaded = false;
  let scheduled = false;

  const styles = `
    :host(.${STOCK_HIDDEN_CLASS}) {
      display: none !important;
    }

    .VolumeBundle > label.${STOCK_HIDDEN_TIER_CLASS} {
      display: none !important;
    }

    /* HEADING */
    div:has(> .VolumeBundle) > div:first-child > p:first-child,
    div:has(> .VolumeBundle__VolumeBundleGrid) > div:first-child > p:first-child,
    div:has(> .VolumeBundle__VolumeBundleInline) > div:first-child > p:first-child {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      width: 100% !important;
      margin: 0 !important;
      color: #e95c4d !important;
      font-size: 14px !important;
      line-height: 1.35 !important;
      font-weight: 600 !important;
      text-align: center !important;
    }

    div:has(> .VolumeBundle) > div:first-child > p:first-child::before,
    div:has(> .VolumeBundle) > div:first-child > p:first-child::after,
    div:has(> .VolumeBundle__VolumeBundleGrid) > div:first-child > p:first-child::before,
    div:has(> .VolumeBundle__VolumeBundleGrid) > div:first-child > p:first-child::after,
    div:has(> .VolumeBundle__VolumeBundleInline) > div:first-child > p:first-child::before,
    div:has(> .VolumeBundle__VolumeBundleInline) > div:first-child > p:first-child::after {
      content: "" !important;
      flex: 1 1 0 !important;
      height: 1px !important;
      background: #e8ded2 !important;
    }

    /* TIER STACK */
    .VolumeBundle {
      gap: 9px !important; /* Adjusts the space between tiers. */
      box-sizing: border-box !important;
      padding-bottom: 12px !important; /* Persistent gap above Add to Cart, including the no-selection state. */
    }

    .Item,
    .InlineItem__Item {
      box-sizing: border-box !important;
      color: #e95c4d !important;
      background: #fffdf6 !important;
      border: 1px solid #e8ded2 !important;
      border-radius: 4px !important;
      box-shadow: none !important;
      transition: border-color .2s ease, background-color .2s ease !important;
    }

    .Item {
      gap: 8px !important;
      padding: 10px 12px !important; /* Main vertical-tier height control. */
    }

    /* Mageworx reserves an empty first grid row for its label/badge. The badge
       now lives beside the pack title, so collapse those three placeholders. */
    .Item__ItemGrid > :nth-child(-n + 3) {
      display: none !important;
    }

    .Item table thead {
      display: none !important; /* Removes the redundant “Flavor” heading. */
    }

    .InlineItem__Item {
      padding: 10px 12px !important;
    }

    .Item__ItemGrid,
    .InlineItem__ItemGrid {
      align-items: center !important;
    }

    .Item__ItemGrid {
      row-gap: 0 !important; /* Centers unselected rows after placeholder collapse. */
    }

    .Item__ItemGrid > .grid-column,
    .InlineItem__ItemGrid > .grid-column {
      align-items: center !important;
    }

    .Item:hover,
    .InlineItem__Item:hover,
    .Item__Selected,
    .InlineItem__Selected {
      color: #e95c4d !important;
      background: #fffdf6 !important;
      border-color: #e95c4d !important;
      box-shadow: none !important;
    }

    .Item__ItemControl:focus-visible + .Item,
    .InlineItem__ItemControl:focus-visible + .InlineItem__Item {
      outline: 1px solid #e95c4d !important;
      outline-offset: 2px !important;
    }

    /* TEXT */
    .Item__ItemTitle,
    .InlineItem__ItemTitle,
    .Item__ItemSubtitle,
    .InlineItem__ItemSubtitle,
    .Item__ItemLabel,
    .InlineItem__ItemLabel,
    .ItemPrice,
    .ItemPrice + span,
    .ItemVariantLabel {
      color: #e95c4d !important;
      -webkit-text-fill-color: #e95c4d !important;
    }

    .Item__ItemTitle,
    .InlineItem__ItemTitle {
      display: inline-flex !important;
      align-items: center !important;
      flex-wrap: wrap !important;
      gap: 5px 8px !important;
      font-size: 13px !important;
      line-height: 1.25 !important;
      font-weight: 600 !important;
    }

    .Item__ItemTitle[data-cuddypup-discount]::after,
    .InlineItem__ItemTitle[data-cuddypup-discount]::after {
      content: attr(data-cuddypup-discount) !important;
      display: inline-block !important;
      color: #fffdf6 !important;
      -webkit-text-fill-color: #fffdf6 !important;
      background: #e95c4d !important;
      border-radius: 3px !important;
      font-size: 12px !important;
      line-height: 1.2 !important;
      font-weight: 500 !important;
      padding: 3px 7px !important;
      white-space: nowrap !important;
    }

    .Item__ItemSubtitle,
    .InlineItem__ItemSubtitle,
    .Item__ItemLabel,
    .InlineItem__ItemLabel,
    .ItemVariantLabel {
      font-size: 11px !important;
      line-height: 1.25 !important;
    }

    .Item__ItemLabel,
    .InlineItem__ItemLabel {
      text-transform: none !important;
    }

    .ItemPrice {
      font-size: 13px !important;
      line-height: 1.25 !important;
      font-weight: 600 !important;
    }

    .ItemPrice + span {
      font-size: 11px !important;
      line-height: 1.25 !important;
    }

    .ItemComparePrice {
      display: none !important; /* Keep the vendor value for the total summary, but hide it inside each tier. */
    }

    /* SAVINGS BADGE */
    .Item__DiscountLabel,
    .InlineItem__DiscountLabel {
      display: none !important; /* Recreated beside the pack title below. */
      color: #fffdf6 !important;
      -webkit-text-fill-color: #fffdf6 !important;
      background: #e95c4d !important;
      border-radius: 3px !important;
      box-shadow: none !important;
      font-size: 12px !important;
      line-height: 1.2 !important;
      font-weight: 500 !important;
      padding: 3px 7px !important;
    }

    /* RADIO CONTROLS */
    .Item__ItemGrid [role="presentation"],
    .InlineItem__ItemGrid [role="presentation"] {
      box-sizing: border-box !important;
      width: 16px !important;
      min-width: 16px !important;
      height: 16px !important;
      background: #fffdf6 !important;
      border: 1px solid #e8ded2 !important;
      border-radius: 50% !important;
      box-shadow: none !important;
    }

    .Item__ItemGrid .Item__RadioSelected,
    .InlineItem__ItemGrid .InlineItem__RadioSelected {
      background: #e95c4d !important;
      border: 3px solid #fffdf6 !important;
      box-shadow: 0 0 0 1px #e95c4d !important;
    }

    /* VARIANT ROWS */
    .Select__VolumeSelect {
      appearance: none !important;
      -webkit-appearance: none !important;
      color: #e95c4d !important;
      -webkit-text-fill-color: #e95c4d !important;
      background-color: #fffdf6 !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3E%3Cpath d='m2 2 6 6 6-6' fill='none' stroke='%23e95c4d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 8px center !important;
      background-size: 10px 6px !important;
      border: 1px solid #e95c4d !important;
      border-radius: 4px !important;
      box-shadow: none !important;
      box-sizing: border-box !important;
      width: 134px !important; /* Ends level with the longest % OFF badge. */
      max-width: 100% !important;
      min-height: 28px !important;
      font-size: 12px !important;
      line-height: 16px !important;
      padding: 4px 24px 4px 8px !important;
    }

    .Select__VolumeSelect:focus-visible {
      outline: 1px solid #e95c4d !important;
      outline-offset: 2px !important;
    }

    .Select__VolumeSelect option {
      color: #e95c4d !important;
      background: #fffdf6 !important;
    }

    .Item table tbody td:first-child,
    .InlineItem__Item table tbody td:first-child {
      vertical-align: middle !important;
    }

    .Item table tbody td:first-child span,
    .InlineItem__Item table tbody td:first-child span {
      color: #e95c4d !important;
      -webkit-text-fill-color: #e95c4d !important;
      font-size: 12px !important;
      margin-top: 0 !important;
      white-space: nowrap !important;
    }

    .cuddypup-deal-summary {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-end !important;
      gap: 4px !important;
      width: 100% !important;
      margin-top: 2px !important;
      margin-bottom: 0 !important; /* Spacing now belongs to the stable bundle root above. */
      color: #e95c4d !important;
      font-size: 14px !important;
      line-height: 1.4 !important;
      font-weight: 500 !important;
      text-align: right !important;
    }

    .cuddypup-deal-summary__line {
      display: flex !important;
      align-items: baseline !important;
      justify-content: flex-end !important;
      flex-wrap: wrap !important;
      gap: 4px !important;
    }

    .cuddypup-deal-summary__compare {
      color: #7ea2fc !important;
      -webkit-text-fill-color: #7ea2fc !important;
      text-decoration: line-through !important;
    }

    .cuddypup-deal-summary__price,
    .cuddypup-deal-summary__save {
      color: #e95c4d !important;
      -webkit-text-fill-color: #e95c4d !important;
      font-weight: 600 !important;
    }

    @media (max-width: 575px) {
      div:has(> .VolumeBundle) > div:first-child > p:first-child,
      div:has(> .VolumeBundle__VolumeBundleGrid) > div:first-child > p:first-child,
      div:has(> .VolumeBundle__VolumeBundleInline) > div:first-child > p:first-child {
        gap: 8px !important;
        font-size: 14px !important;
      }

      .Item,
      .InlineItem__Item {
        padding: 9px 10px !important;
      }
    }
  `;

  const preserveThemeVariants = (host) => {
    if (!document.getElementById(THEME_VARIANTS_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = THEME_VARIANTS_STYLE_ID;
      style.textContent = `
        .product-information--inner.${THEME_VARIANTS_SCOPE_CLASS}
          > variant-selects:not(.variant-selects--sticky) {
          display: block !important;
        }
      `;
      document.head.appendChild(style);
    }

    host.closest('.product-information--inner')?.classList.add(THEME_VARIANTS_SCOPE_CLASS);
  };

  const getQuantity = (item) => {
    const root = item.getRootNode();
    const label = item.closest('label');
    if (!(root instanceof ShadowRoot) || !label) return null;

    const labels = [...root.querySelectorAll('.VolumeBundle > label')];
    const tierIndex = labels.indexOf(label);
    const quantity = Number(window.__cuddypupVolumeOfferRule?.quantities?.[tierIndex]);
    return Number.isInteger(quantity) && quantity > 0 ? quantity : null;
  };

  const parseMoney = (text) => {
    const match = text.trim().match(/^(\D*?)([-\d\s.,]+)(\D*)$/u);
    if (!match) return null;

    const [, prefix, raw, suffix] = match;
    const comma = raw.lastIndexOf(',');
    const dot = raw.lastIndexOf('.');
    const decimalIndex = Math.max(comma, dot);
    const decimalSeparator = decimalIndex >= 0 ? raw[decimalIndex] : ',';
    const fractionLength = decimalIndex >= 0 ? raw.length - decimalIndex - 1 : 2;
    const normalized = raw
      .replace(/\s/g, '')
      .replace(decimalSeparator === ',' ? /\./g : /,/g, '')
      .replace(decimalSeparator, '.');
    const value = Number(normalized);
    return Number.isFinite(value)
      ? { value, prefix, suffix, decimalSeparator, fractionLength }
      : null;
  };

  const formatMoney = (money, value) => {
    const decimals = Math.max(0, Math.min(2, money.fractionLength));
    const formatted = value.toFixed(decimals).replace('.', money.decimalSeparator);
    return `${money.prefix}${formatted}${money.suffix}`;
  };

  const loadStorefrontProduct = () => {
    if (productLoadStarted || !/\/products\//.test(location.pathname)) return;
    productLoadStarted = true;
    const endpoint = `${location.pathname.replace(/\/$/, '')}.js`;
    fetch(endpoint, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((product) => {
        if (!product?.variants?.length) return;
        storefrontProduct = product;
        schedule();
      })
      .catch(() => {});
  };

  const loadInventorySnapshot = () => {
    if (inventoryLoaded) return;
    const node = document.getElementById('cuddypup-product-inventory');
    if (!node) return;

    try {
      const snapshot = JSON.parse(node.textContent || '{}');
      if (!Array.isArray(snapshot.variants)) return;
      snapshot.variants.forEach((variant) => {
        const id = Number(variant?.id);
        const quantity = Number(variant?.quantity);
        if (!Number.isFinite(id)) return;
        inventoryByVariantId.set(id, {
          quantity: Number.isFinite(quantity) ? quantity : null,
          policy: variant?.policy || null,
          management: variant?.management || null,
        });
      });
      inventoryLoaded = true;
    } catch (_) {
      /* Unknown inventory must never hide an offer. */
    }
  };

  const variantForValues = (values) => storefrontProduct?.variants?.find((candidate) =>
    values.every((value, index) => candidate.options?.[index] === value)
  );

  const productInventoryCapacity = () => {
    if (!inventoryLoaded || !storefrontProduct?.variants?.length) return null;
    let total = 0;
    for (const variant of storefrontProduct.variants) {
      const inventory = inventoryByVariantId.get(Number(variant.id));
      if (!inventory) return null;
      /* Untracked stock or "continue selling" makes the volume offer unlimited. */
      if (!inventory.management || inventory.policy === 'continue') return Infinity;
      if (!Number.isFinite(inventory.quantity)) return null;
      total += Math.max(0, inventory.quantity);
    }
    return total;
  };

  const updateStockVisibility = (host, root) => {
    loadInventorySnapshot();
    const capacity = productInventoryCapacity();
    if (capacity === null) return;

    const records = [...root.querySelectorAll('.VolumeBundle > label')].map((label) => {
      const item = label.querySelector('.Item, .InlineItem__Item');
      const quantity = item ? getQuantity(item) : null;
      return { label, item, quantity };
    });

    if (!records.length || records.some(({ quantity }) => !Number.isInteger(quantity) || quantity < 1)) {
      records.forEach(({ label }) => {
        label.classList.remove(STOCK_HIDDEN_TIER_CLASS);
        label.removeAttribute('aria-hidden');
      });
      host.classList.remove(STOCK_HIDDEN_CLASS);
      return;
    }

    records.forEach((record) => {
      record.hidden = Number.isFinite(capacity) && record.quantity > capacity;
      record.label.classList.toggle(STOCK_HIDDEN_TIER_CLASS, record.hidden);
      if (record.hidden) record.label.setAttribute('aria-hidden', 'true');
      else record.label.removeAttribute('aria-hidden');
    });

    const hasMultiBuy = records.some(({ quantity, hidden }) => quantity > 1 && !hidden);
    host.classList.toggle(STOCK_HIDDEN_CLASS, !hasMultiBuy);

    const selectedHidden = records.find(({ item, hidden }) =>
      hidden && item?.matches('.Item__Selected, .InlineItem__Selected')
    );
    if (selectedHidden) {
      const fallback = records.find(({ hidden }) => !hidden);
      fallback?.label.querySelector('input[type="radio"]')?.click();
    }
  };

  const getSelectedVariantCents = (item, quantity) => {
    if (!storefrontProduct?.variants?.length) return null;
    const rows = [...item.querySelectorAll('tbody tr')];
    if (!rows.length) {
      /* Single-variant products do not render variant rows in Mageworx. Use
         the storefront price once per unit instead of trying to infer it from
         Mageworx's transient tier text. */
      if (storefrontProduct.variants.length !== 1) return null;
      const cents = Number(storefrontProduct.variants[0]?.price);
      return Number.isFinite(cents) ? Array(Math.max(1, quantity)).fill(cents) : null;
    }

    const prices = rows.map((row) => {
      const values = [...row.querySelectorAll('select')].map((select) => select.value);
      if (!values.length) return null;
      const variant = variantForValues(values);
      const cents = Number(variant?.price);
      return Number.isFinite(cents) ? cents : null;
    });

    return prices.every((price) => Number.isFinite(price)) ? prices : null;
  };

  const getCompareUnitFallback = (root) => {
    const candidates = [...root.querySelectorAll('.ItemComparePrice')]
      .map((node) => {
        const item = node.closest('.Item, .InlineItem__Item');
        const money = parseMoney(priceStates.get(node)?.vendorText || node.textContent);
        return money && item ? money.value / getQuantity(item) : null;
      })
      .filter((value) => Number.isFinite(value) && value > 0)
      .sort((a, b) => a - b);
    return candidates.length ? candidates[Math.floor(candidates.length / 2)] : null;
  };

  const setPriceTotal = (node, totalCents, quantity) => {
    if (!node || !Number.isFinite(totalCents)) return;
    const prior = priceStates.get(node);
    const money = parseMoney(prior?.vendorText || node.textContent.trim());
    if (!money) return;

    const vendorText = formatMoney(money, totalCents / 100);
    const renderedText = formatMoney(money, totalCents / (100 * Math.max(1, quantity)));
    const state = { vendorText, renderedText };
    if (node.textContent.trim() !== renderedText) node.textContent = renderedText;
    priceStates.set(node, state);
  };

  const stabilizePrice = (root, item, quantity) => {
    const priceNode = item.querySelector('.ItemPrice');
    const compareNode = item.querySelector('.ItemComparePrice');
    const variantCents = getSelectedVariantCents(item, quantity);

    if (variantCents?.length === quantity) {
      const baseTotalCents = variantCents.reduce((sum, cents) => sum + cents, 0);
      const discountText =
        item.querySelector('.Item__DiscountLabel, .InlineItem__DiscountLabel')?.textContent ||
        item.querySelector('.Item__ItemTitle, .InlineItem__ItemTitle')?.dataset.cuddypupDiscount ||
        '';
      const percentMatch = discountText.match(/(\d+(?:[.,]\d+)?)\s*%/);
      const percent = percentMatch ? Number(percentMatch[1].replace(',', '.')) : 0;
      const multiplier = Math.max(0, 1 - percent / 100);
      /* Mageworx rounds each discounted unit upward to the next cent. */
      const discountedTotalCents = variantCents.reduce(
        (sum, cents) => sum + Math.ceil(cents * multiplier - 1e-8),
        0
      );

      setPriceTotal(priceNode, discountedTotalCents, quantity);
      if (compareNode && percent > 0) setPriceTotal(compareNode, baseTotalCents, quantity);
      return;
    }

    /* If product JSON is unavailable, leave Mageworx's own values alone.
       Inferring a unit price from another tier can halve single-pack prices. */
  };

  const showUnitPrice = (priceNode, quantity) => {
    if (!priceNode) return;

    const current = priceNode.textContent.trim();
    let state = priceStates.get(priceNode);
    if (!state || current !== state.renderedText) {
      state = { vendorText: current, renderedText: current };
    }

    const money = parseMoney(state.vendorText);
    if (!money) return;

    const renderedText = formatMoney(money, money.value / Math.max(1, quantity));
    if (current !== renderedText) priceNode.textContent = renderedText;
    state.renderedText = renderedText;
    priceStates.set(priceNode, state);
  };

  const updateDealSummary = (root) => {
    const bundle = root.querySelector('.VolumeBundle');
    const selected = root.querySelector('.Item__Selected');
    if (!bundle || !selected) return;

    const priceNode = selected.querySelector('.ItemPrice');
    const compareNode = selected.querySelector('.ItemComparePrice');
    const price = parseMoney(priceStates.get(priceNode)?.vendorText || '');
    const compare = parseMoney(priceStates.get(compareNode)?.vendorText || '');
    if (!price) return;

    let summary = bundle.querySelector(':scope > .cuddypup-deal-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'cuddypup-deal-summary';
      summary.innerHTML = `
        <div class="cuddypup-deal-summary__line">
          <span>Total price:</span>
          <span class="cuddypup-deal-summary__compare"></span>
          <span class="cuddypup-deal-summary__price"></span>
        </div>
        <div class="cuddypup-deal-summary__line">
          <span>You save:</span>
          <span class="cuddypup-deal-summary__save"></span>
        </div>`;
      bundle.appendChild(summary);
    }

    const compareText = compare ? formatMoney(compare, compare.value) : '';
    const priceText = formatMoney(price, price.value);
    const savings = Math.max(0, (compare?.value ?? price.value) - price.value);
    const savingsText = formatMoney(compare || price, savings);
    const compareElement = summary.querySelector('.cuddypup-deal-summary__compare');

    if (compareElement.textContent !== compareText) compareElement.textContent = compareText;
    compareElement.hidden = !compare;
    const priceElement = summary.querySelector('.cuddypup-deal-summary__price');
    if (priceElement.textContent !== priceText) priceElement.textContent = priceText;
    const saveElement = summary.querySelector('.cuddypup-deal-summary__save');
    if (saveElement.textContent !== savingsText) saveElement.textContent = savingsText;
  };

  const decorate = (root) => {
    root.querySelectorAll('.Item, .InlineItem__Item').forEach((item) => {
      const quantity = getQuantity(item);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const title = item.querySelector('.Item__ItemTitle, .InlineItem__ItemTitle');
      const discount = item.querySelector('.Item__DiscountLabel, .InlineItem__DiscountLabel');
      const discountText = discount?.textContent.trim() || '';

      if (title && title.dataset.cuddypupDiscount !== discountText) {
        if (discountText) title.dataset.cuddypupDiscount = discountText;
        else delete title.dataset.cuddypupDiscount;
      }

      showUnitPrice(item.querySelector('.ItemPrice'), quantity);
      showUnitPrice(item.querySelector('.ItemComparePrice'), quantity);
      stabilizePrice(root, item, quantity);

      const eachLabel = item.querySelector('.ItemPrice')?.nextElementSibling;
      if (eachLabel && eachLabel.textContent.trim() !== '/each') {
        eachLabel.textContent = ' /each';
      }

      item.querySelectorAll('table tbody td:first-child span').forEach((number) => {
        const clean = number.textContent.trim().replace(/\.\s*$/, '');
        if (number.textContent.trim() !== clean) number.textContent = clean;
      });
    });

    updateDealSummary(root);
    updateStockVisibility(root.host, root);
  };

  const enhance = (host) => {
    loadStorefrontProduct();
    preserveThemeVariants(host);
    host.style.display = 'block';
    host.style.width = '100%';
    host.style.maxWidth = '100%';
    host.style.minWidth = '0';

    const root = host.shadowRoot;
    if (!root) return;

    if (!root.querySelector(`#${STYLE_ID}`)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = styles;
      root.appendChild(style);
    }

    decorate(root);

    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      root.addEventListener('change', schedule);
      let decorating = false;
      new MutationObserver(() => {
        if (decorating) return;
        decorating = true;
        queueMicrotask(() => {
          decorating = false;
          if (!root.querySelector(`#${STYLE_ID}`)) enhance(host);
          else decorate(root);
        });
      }).observe(root, { childList: true, characterData: true, subtree: true });
    }
  };

  const scan = () => {
    scheduled = false;
    document.querySelectorAll('mw-volume-bundle').forEach(enhance);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  };

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  /* The custom element can exist before Mageworx attaches its shadow root;
     attachment itself is not observable from the document tree. */
  let attempts = 0;
  const rootTimer = window.setInterval(() => {
    scan();
    attempts += 1;
    if (attempts >= 120) window.clearInterval(rootTimer);
  }, 250);

  window.addEventListener('load', schedule, { once: true });
  scan();
})();
